<style>
/* Responsive tweaks for very small screens */
@media (max-width: 480px) {
  .appointment_logo img {
    max-width: 90px;
  }

  .applicant_links a {
    font-size: 12px;
    margin: 0 0.25rem;
  }

  .mobile-links a {
    font-size: 12px;
    padding: 8px 0;
  }
}
</style>
<template>
  <div class="appointment_header">
    <div class="container py-2">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Logo -->
        <div class="appointment_logo">
          <a :href="LangingHomePage">
            <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMS HEALTH" />
          </a>
        </div>

        <!-- Toggle Icon (mobile only) -->
        <div class="menu-icon d-md-none" @click="toggleMenu">
          <i class="fas fa-bars"></i>
        </div>

        <!-- Desktop Menu -->
        <div class="applicant_links d-none d-md-flex align-items-center">
          <a :href="LangingHomePage">Home</a>
          <span class="separator">|</span>
          <a href="https://www.kimshealth.org/trivandrum/visa_medicals/">FAQ</a>
          <span class="separator">|</span>
          <a href="#" @click.prevent="handleTrackClick">Track Appointment(s)</a>
        </div>
      </div>

      <!-- Mobile Menu -->
      <div
        class="mobile-links flex-column mt-2"
        v-show="isMobileMenuVisible"
      >
        <a :href="LangingHomePage">Home</a>
        <a href="https://www.kimshealth.org/trivandrum/visa_medicals/">FAQ</a>
        <a href="#" @click.prevent="handleTrackClick">Track Appointment(s)</a>
      </div>
    </div>
  </div>
</template>
<script>
import { LogoutPage } from '@/api/Post/action.js';
import Swal from 'sweetalert2';
export default {
  data() {
    return {
      LangingHomePage: '/',
      trackAppointment: '/trackAppointment',
      isMobileMenuVisible: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMobileMenuVisible = !this.isMobileMenuVisible;
    },
    handleTrackClick() {
      LogoutPage()
        .then(() => {
          //console.log('logot success');
          localStorage.removeItem('authToken');
          this.$router.push({ name: 'trackAppointment' });
        })
        .catch((error) => {
          ///console.log('logot failed');
          this.$router.push({ name: 'trackAppointment' });
        });
    },
  },
};
</script>
